<template>
  <div>
    <pdf-preview
      v-show="inPreview"
      :inPreview="inPreview"
      :generatingPreview="generatingPreview"
      :saving="saving"
      :pdfUrl="pdfUrl"
      :backToForm="backToForm"
      :save="save"
    />
    <div v-show="!inPreview">
      <form class="mb-5" autocomplete="off" @submit.prevent>
        <h2>
          RESOLUCIÓN EXENTA
        </h2>
        <div class="row">
          <div class="col-6">
            <b-form-group>
              <label for="fullName">
                Unidad
                <span v-html="required('unitUser')"/>
              </label>
              <list-user-groups
                class="w-100"
                autocomplete
                label=""
                name="unitUser"
                data-vv-as="unidad"
                data-cy="unit-user"
                ref="groupStep"
                v-model="formData.unitUser"
                :danger="errors.has('unitUser')"
                :danger-text="errors.first('unitUser')"
                v-validate="'required'"
                @full-group="formData.unitUserLabel = $event.label"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('unitUser')">
                {{ $validator.errors.first('unitUser') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-6 mb-3 mt-3">
            <b-form-group>
              <div class="row">
                <label for="office">
                  Sucursal
                  <span v-html="required('office')"/>
                </label>
                <b-form-radio-group
                  class="col-4"
                  data-cy="office"
                  name="office"
                  data-vv-as="sucursal"
                  v-model="formData.office"
                  :state="$validator.errors.has('office') ? false : null"
                  :danger="$validator.errors.has('office')"
                  :danger-text="$validator.errors.first('office')"
                  v-validate="'required'"
                >
                  <b-form-radio value="Santiago" class="ml-3 mr-5">Santiago</b-form-radio>
                  <b-form-radio value="Peñaflor" class="ml-3 mr-5">Peñaflor</b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback v-if="$validator.errors.has('office')">
                  {{ $validator.errors.first('office') }}
                </b-form-invalid-feedback>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <label for="birthDate">
                Fecha
                <span v-html="required('date')"/>
              </label>
              <date-picker
                :class="{
                'w-100': true,
                'danger': $validator.errors.has('date'),
              }"
                data-cy="date"
                name="date"
                data-vv-as="fecha"
                v-model="formData.date"
                format="YYYY-MM-DD"
                disabled
                value-type="YYYY-MM-DD"
                v-validate="'required'"
                :danger="$validator.errors.has('date')"
              />
              <v-invalid-feedback v-if="$validator.errors.has('date')">
                {{ $validator.errors.first('date') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="matter">
                Materia
                <span v-html="required('matter')"/>
              </label>
              <div
                class="row"
                v-for="(matter, index) in formData.matter"
                :key="`matter-${index}`"
              >
                <div class="col-md-9 mt-3">
                  <b-form-textarea
                    rows="2"
                    data-cy='matter'
                    name='matter'
                    data-vv-as='materia'
                    placeholder='Ingrese la materia...'
                    v-model="matter.text"
                    :state="$validator.errors.has('matter') ? false : null"
                    :danger="$validator.errors.has('matter')"
                    :danger-text="$validator.errors.first('matter')"
                    v-validate="'required|min: 1'"
                  />
                  <b-form-invalid-feedback v-if="$validator.errors.has('matter')">
                    Ingresa al menos una materia
                  </b-form-invalid-feedback>
                </div>
                <div class="col-md-3 mt-6">
                  <div class="text-center">
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="removeMatter(index)"
                    >
                      Eliminar fila
                    </vs-button>
                  </div>
                </div>
              </div>
              <div class="text-right mt-5">
                <vs-button
                  class="w-100"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="addMatterItem()"
                >
                  Agregar materia
                </vs-button>
              </div>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="views">
                Vistos
                <span v-html="required('views')"/>
              </label>
              <div
                class="row"
                v-for="(view, index) in formData.views"
                :key="`view-${index}`"
              >
                <div class="col-md-9 mt-3">
                  <b-form-textarea
                    rows="2"
                    data-cy='view'
                    name='view'
                    data-vv-as='vistos'
                    placeholder='Ingrese el visto...'
                    v-model="view.text"
                    :state="$validator.errors.has('view') ? false : null"
                    :danger="$validator.errors.has('view')"
                    :danger-text="$validator.errors.first('view')"
                    v-validate="'required|min: 1'"
                  />
                  <b-form-invalid-feedback v-if="$validator.errors.has('view')">
                    Ingresa al menos un visto
                  </b-form-invalid-feedback>
                </div>
                <div class="col-md-3 mt-6">
                  <div class="text-center">
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="removeView(index)"
                    >
                      Eliminar fila
                    </vs-button>
                  </div>
                </div>
              </div>
              <div class="text-right mt-5">
                <vs-button
                  class="w-100"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="addViewsItem()"
                >
                  Agregar visto
                </vs-button>
              </div>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="considering">
                Considerando
                <span v-html="required('considering')"/>
              </label>
              <div
                class="row"
                v-for="(considering, index) in formData.considering"
                :key="`considering-${index}`"
              >
                <div class="col-md-9 mt-3">
                  <b-form-textarea
                    rows="2"
                    data-cy='considering'
                    name='considering'
                    data-vv-as='considerando'
                    placeholder='Ingrese el texto...'
                    v-model="considering.text"
                    :state="$validator.errors.has('considering') ? false : null"
                    :danger="$validator.errors.has('considering')"
                    :danger-text="$validator.errors.first('considering')"
                    v-validate="'required|min: 1'"
                  />
                  <b-form-invalid-feedback v-if="$validator.errors.has('considering')">
                    Ingresa al menos una elemento
                  </b-form-invalid-feedback>
                </div>
                <div class="col-md-3 mt-6">
                  <div class="text-center">
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="removeConsidering(index)"
                    >
                      Eliminar fila
                    </vs-button>
                  </div>
                </div>
              </div>
              <div class="text-right mt-5">
                <vs-button
                  class="w-100"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="addConsidereItem()"
                >
                  Agregar considerando
                </vs-button>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-form-group label="Establece *">
              <editor-text
                :danger="errors.has('stablishment')"
                :danger-text="errors.first('stablishment')"
                data-cy="stablishment"
                data-vv-as="establece"
                :max-length="8000"
                name="stablishment"
                ref="stablishment"
                v-validate="'required'"
                :toolbarItems=" {
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]}"
                v-model="formData.stablishment"
                with-counter
              />
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-form-group label="Déjese *">
              <editor-text
                :danger="errors.has('leave')"
                :danger-text="errors.first('leave')"
                data-cy="leave"
                data-vv-as="déjese"
                :max-length="8000"
                name="leave"
                ref="leave"
                v-validate="'required'"
                :toolbarItems=" {
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]}"
                v-model="formData.leave"
                with-counter
              />
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-form-group label="Comuníquese *">
              <editor-text
                :danger="errors.has('communicate')"
                :danger-text="errors.first('communicate')"
                data-cy="communicate"
                data-vv-as="comuníquese"
                :max-length="8000"
                name="communicate"
                ref="communicate"
                v-validate="'required'"
                :toolbarItems=" {
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]}"
                v-model="formData.communicate"
                with-counter
              />
            </b-form-group>
          </div>
          <div class="col-6">
            <label for="MOC">MOC</label>
            <b-input
              name="user"
              placeholder="MOC"
              v-model="formData.user"
              data-vv-as="user"
              data-cy="user"
              disabled
              v-validate="'required'"
              :danger="$validator.errors.has('user')"
              :danger-text="$validator.errors.first('user')"
              :state="$validator.errors.has('user') ? false : null"

            />
          </div>
          <div class="col-6">
            <label for="numberProcess">N° proceso</label>
            <span v-html="required('numberProcess')"/>
            <b-input
              name="numberProcess"
              placeholder="N° proceso"
              v-model="formData.numberProcess"
              data-vv-as="nro. proceso"
              data-cy="numberProcess"
              v-validate="'required|max:10'"
              :danger="$validator.errors.has('numberProcess')"
              :danger-text="$validator.errors.first('numberProcess')"
              :state="$validator.errors.has('numberProcess') ? false : null"
            />
            <b-form-invalid-feedback v-if="$validator.errors.has('numberProcess')">
              {{ $validator.errors.first('numberProcess') }}
            </b-form-invalid-feedback>
          </div>
          <div class="col-6 mt-2">
            <label for="director">Director Ejecutivo</label>
            <span v-html="required('director')"/>
            <select-options
              options-group="res-director"
              :alphabetical-sort=true
              name="director"
              placeholder=""
              v-model="formData.director"
              data-vv-as="director"
              data-cy="director"
              v-validate="{required: !formData.alternate }"
              select-first
              :danger="$validator.errors.has('director')"
              :danger-text="$validator.errors.first('director')"
              :state="$validator.errors.has('director') ? false : null"
              @input="formData.alternate = ''"
            />
            <v-invalid-feedback v-if="$validator.errors.has('director')">
              {{ $validator.errors.first('director') }}
            </v-invalid-feedback>
          </div>
          <div class="col-6 mt-2">
            <label for="alternate">Suplente</label>
            <select-options
              options-group="res-alternate"
              :alphabetical-sort=true
              name="alternate"
              placeholder=""
              v-model="formData.alternate"
              data-vv-as="suplente"
              data-cy="alternate"
              :danger="$validator.errors.has('alternate')"
              :danger-text="$validator.errors.first('alternate')"
              :state="$validator.errors.has('alternate') ? false : null"
              @input="formData.director = ''"
            />
          </div>
        </div>
      </form>
      <form-action-buttons
        :saving="saving"
        :preview="preview"
        :back="back"
        :save="save"
      />
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';

import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';
import PdfPreview from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/PdfPreview';
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import VInvalidFeedback from '@/febos/global/customDocuments/components/VInvalidFeedback';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';

import { mapGetters } from 'vuex';

import SelectOptions from '@/febos/global/customDocuments/components/SelectOptions';
import FormActionButtons
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/FormActionButtons';
import { showToast } from '@/febos/global/customDocuments/vistas/empresas/61980520-8/utils';

export default {
  components: {
    FormActionButtons,
    SelectOptions,
    EditorText,
    VInvalidFeedback,
    PdfPreview,
    ListUserGroups,
    DatePicker
  },
  data() {
    return {
      saving: false,
      dynamicFileSelectorValid: false,
      error: {
        message: ''
      },
      inPreview: false,
      generatingPreview: false,
      pdfUrl: '',
      formData: {
        unitUser: '',
        unitUserLabel: '',
        office: 'Santiago',
        // date: this.$moment().format('DD MMMM YYYY'),
        date: this.$moment().format('YYYY-MM-DD'),
        matter: [{
          text: ''
        }],
        views: [{
          text: ''
        }],
        considering: [{
          text: ''
        }],
        stablishment: '',
        leave: '',
        communicate: '',
        user: '',
        numberProcess: '',
        director: '',
        alternate: '',
      }
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('List', [
      'userGroupsState'
    ]),
  },
  methods: {
    removeMatter(index) {
      if (this.formData.matter.length === 1) {
        this.formData.matter = [{
          text: ''
        }];
        return;
      }

      this.formData.matter.splice(index, 1);
    },
    removeView(index) {
      if (this.formData.views.length === 1) {
        this.formData.views = [{
          text: ''
        }];
        return;
      }

      this.formData.views.splice(index, 1);
    },
    removeConsidering(index) {
      if (this.formData.considering.length === 1) {
        this.formData.considering = [{
          text: ''
        }];
        return;
      }

      this.formData.considering.splice(index, 1);
    },
    addMatterItem() {
      // max 5
      if (this.formData.matter.length === 5) {
        this.$vs.notify({
          title: 'Uups',
          text: 'Ya superaste el máximo de ítems',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      this.formData.matter.push({ text: '' });
    },
    addViewsItem() {
      // maxx 10
      if (this.formData.views.length === 10) {
        this.$vs.notify({
          title: 'Uups',
          text: 'Ya superaste el máximo de ítems',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }

      this.formData.views.push({ text: '' });
    },
    addConsidereItem() {
      // max 5
      if (this.formData.considering.length === 5) {
        this.$vs.notify({
          title: 'Uups',
          text: 'Ya superaste el máximo de ítems',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      this.formData.considering.push({ text: '' });
    },
    required(fieldName) {
      const item = this.$validator.fields.items.find((_item) => _item.name === fieldName);
      if (!item || !item.rules || !Object.keys(item.rules).length || !Object.keys(item.rules).includes('required')) {
        return '';
      }
      return "<span class='text-danger'><b>*</b></span>";
    },
    backToForm() {
      this.inPreview = false;
    },
    async validateForm() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'Revisa los campos marcados en rojo',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
      }
      return validForm;
    },
    getFormData() {
      return {
        ...this.formData,
        matter: this.formData.matter.map((item, index) => ({ ...item, number: index + 1 })),
        considering: this.formData.considering.map((item, index) => ({ ...item, number: index + 1 })),
        views: this.formData.views.map((item, index) => ({ ...item, number: index + 1 })),
      };
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('RESINH', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    async save() {
      this.$validator.errors.clear();
      const isValid = await this.validateForm();
      if (!isValid) {
        return;
      }

      this.error.message = '';
      this.saving = true;

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
          },
          formData: {
            ...this.getFormData(),
          }
        };

        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    back() {
      window.history.back();
    },
    async preview() {
      const isValid = await this.validateForm();
      if (!isValid) {
        return;
      }

      this.pdfUrl = '';
      this.inPreview = true;
      this.generatingPreview = true;

      try {
        showToast(this, 'Generando previsualización', 'En camino...', 'primary', 3000);

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.getFormData(),
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          showToast(this, 'No se pudo generar la previsualización', 'Ups!', 'warning', 5000);
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } finally {
        this.generatingPreview = false;
      }
    },
    getInitials(fullName) {
      const words = fullName.split(' ');
      let initials = '';

      for (let i = 0; i < words.length; i++) {
        if (words[i].length > 0) { // Ensure the word is not empty
          initials += words[i].charAt(0).toUpperCase();
        }
      }
      return initials;
    }
  },
  created() {
    this.formData.user = this.getInitials(this.currentUser.nombre);
    if (this.userGroupsState.list.length) {
      const groups = this.userGroupsState.list.filter((item) => item.isOffice === 'N');
      this.formData.unitUser = groups[0].id;
      this.formData.unitUserLabel = groups[0].label;
    }
  }
};
</script>
